import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, CUSTOMER_KEY } from "@/lib/api";

const CustomerContext = createContext(null);

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(CUSTOMER_KEY)) return setCustomer(false);
    try {
      const { data } = await api.get("/customer/me");
      setCustomer(data);
    } catch {
      localStorage.removeItem(CUSTOMER_KEY);
      setCustomer(false);
    }
  }, []);

  useEffect(() => {
    // Returning from Google: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const completeLogin = (data) => {
    localStorage.setItem(CUSTOMER_KEY, data.token);
    setCustomer(data.customer);
  };

  const logout = async () => {
    await api.post("/customer/logout").catch(() => {});
    localStorage.removeItem(CUSTOMER_KEY);
    localStorage.removeItem("uplink_contact");
    setCustomer(false);
  };

  return (
    <CustomerContext.Provider value={{ customer, login, logout, refresh, completeLogin }}>
      {children}
    </CustomerContext.Provider>
  );
}

export const useCustomer = () => useContext(CustomerContext);
